<template>
  <el-drawer
    title="Detalle de Balances de clientes"
    :visible.sync="showDrawer"
    :before-close="beforeClose"
    size="75%"
    :modal="false"
  >
    <el-card class="card">
      <div>
        <el-row>
          <el-col :span="2" :offset="1">
            <h2>Cliente:</h2>
          </el-col>
          <el-col :span="10">
            <h2>
              <strong
                ><b>{{ CurrentClienData.clientName }}</b></strong
              >
            </h2>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-row
          class="flex-container-balance"
          style="padding-bottom: 0px; margin-bottom: 0px"
        >
          <el-col :span="12">
            <!--<h4>Cliente</h4>-->
            <el-select
              size="mini"
              v-model="ClientSelected"
              :loading="loading_Balance_Data"
              filterable
              clearable
              placeholder="Tarjeta Habiente"
              @change="onCardHolderChanging"
              class="supliers_select"
            >
              <el-option
                v-for="item in dataClients"
                :key="item.cardHolderId"
                :label="item.cardHolderName"
                :value="item.cardHolderId"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="20" type="flex" justify="end">
              <el-col :span="6" :offset="1">
                <!--<h4>filtro diferencias</h4>-->
                <el-select
                  size="mini"
                  v-model="DiffSelected"
                  :loading="loading_Balance_Data"
                  filterable
                  placeholder="Filtro diferencias"
                  @change="onDiffChanging"
                  class="supliers_select"
                >
                  <el-option
                    v-for="(item, index) in DiffOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <rabbey-toolbox
                filter-placeholder="Buscar por nombre"
                filterables
                @filter-search="search = $event"
              />
            </el-row>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <rabbey-table3
            :height="600"
            style="overflow: auto"
            ref="customerTable"
            :columns="ClientsBalanceDetailledColumns"
            v-loading="loading_Balance_Data"
            :search="search"
            :border="true"
            :stripe="true"
            :data="FilteredData"
            :actions="ClientsBalanceDetailledActions"
            :show-summary="true"
            :summary-method="getSummaries"
          />
        </el-row>
      </div>
    </el-card>
  </el-drawer>
</template>

<script>
import {
  ClientsBalanceDetailledColumns,
  ClientsBalanceDetailledActions
} from "@/views/apps/ncfmovil/columnsTables/BalanceReportColumns.js";
import { formatMonto } from "@/utils";

export default {
  name: "ClientBalanceReportDetailed",
  props: {
    showDrawer: {
      type: Boolean,
      default: false
    },
    CurrentClienData: {
      type: Object,
      default: () => {}
    }
    /*
    ClienId: {
      type: Number,
      default: 0
    },
    SuplierId: {
      type: Number,
      default: 0
    }
    */
  },
  data() {
    return {
      ClientsBalanceDetailledColumns,
      ClientsBalanceDetailledActions,
      SupplierBalanceDataDetail: [],
      loading_Balance_Data: false,
      search: "",
      ClientSelected: "",
      CardHolderFiltered: [],
      FilteredData: [],
      DiffSelected: "All",
      DiffOptions: [
        {
          value: "All",
          label: "Todos con o sin diferencias de Balances"
        },
        {
          value: "Diff",
          label: "Tiene diferencias de Balances"
        },
        {
          value: "NoTDiff",
          label: "No Tiene diferencias de Balances"
        }
      ]
    };
  },
  mounted() {
    //console.log("this.CurrentClienData: ", this.CurrentClienData)
    this.GetBalanceReportDetailData(
      this.CurrentClienData.clientid,
      this.CurrentClienData.supplierId
    );
  },
  computed: {
    dataClients() {
      //console.log("SupplierBalanceDataDetail: ", this.SupplierBalanceDataDetail)
      let ClientsData = this.SupplierBalanceDataDetail.map((BalanceDetail) => {
        return {
          cardHolderId: BalanceDetail.cardHolderId,
          cardHolderName: BalanceDetail.cardHolderName
        };
      });
      //console.log("ClientsData: ", ClientsData)
      return ClientsData;
    }
  },
  methods: {
    async GetBalanceReportDetailData(ClienId = null, SuplierId = null) {
      //console.log("GetBalanceReportDetailData: ","C ", ClienId, "S ", SuplierId )
      this.loading_Balance_Data = true;
      await this.$http
        .get(
          `/api/tennos/GetSupplierBalanceReportDetail?EmpresaId=${SuplierId}&ClientId=${ClienId}`
        )
        .then((resp) => {
          this.FilteredData = this.SupplierBalanceDataDetail = resp.data;
          /*
          this.SupplierBalanceDataDetail.forEach((cardHolder) => {
            cardHolder.OpenDetail = this.OpenDetail;
          });
          */
          /*
          console.log(
            "SupplierBalanceDataDetail: ",
            this.SupplierBalanceDataDetail
          );
          */
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading_Balance_Data = false;
        });
      //console.log("Master Report: ", await this.SupplierBalanceDataMaster)
    },
    beforeClose() {
      this.$emit("OncloseDetail");
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index < 1) {
          return;
        }
        if (index === 1) {
          sums[index] = "Totales";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = formatMonto(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    onCardHolderChanging(CardHolderId) {
      //console.log("CardHolderId: ", CardHolderId)
      //console.log("SupplierBalanceDataDetail: ", this.SupplierBalanceDataDetail)

      if (!CardHolderId) {
        this.FilteredData = this.CardHolderFiltered =
          this.SupplierBalanceDataDetail;
      } else {
        this.FilteredData = this.CardHolderFiltered =
          this.SupplierBalanceDataDetail.filter(
            (balanceData) => balanceData.cardHolderId === CardHolderId
          );
        //console.log("CardHolderFiltered: ", this.CardHolderFiltered)
      }
    },
    async onDiffChanging(concept) {
      switch (concept) {
        case "All": {
          this.FilteredData = this.SupplierBalanceDataDetail;
          break;
        }
        case "Diff": {
          this.FilteredData = this.SupplierBalanceDataDetail.filter(
            (balanceData) => balanceData.balanceDiff !== 0
          );
          break;
        }
        case "NoTDiff": {
          this.FilteredData = this.SupplierBalanceDataDetail.filter(
            (balanceData) => balanceData.balanceDiff === 0
          );
          break;
        }
        default: {
          break;
        }
      }
    }
  }
};
</script>

<style lang="css" scoped>
.flex-container-balance {
  display: flex;
  /*height: 200px;*/
  align-items: center;
}

.supliers_select {
  min-width: 60%;
}

.card {
  margin: 10;
}
</style>
